import { Component } from 'react';
// Composants
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEnvelope, faPlus, faSignOutAlt, faTimes, faTrashAlt, faUser, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { Button, Divider, Form, Grid, Input, Label, Message, Select } from 'semantic-ui-react';
import SubscriptionUsersLimitReachedMessage from '../../Messages/SubscriptionUsersLimitReachedMessage';
// Librairies
import { isMobileOnly } from 'react-device-detect';
import i18n from '../../../locales/i18n';
import { connect } from 'react-redux';
import { setActiveOrganization } from '../../../actionCreators/usersActions';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
// Services
import OrganizationsService from '../../../services/OrganizationsService';
// Utils
import FormattersUtil from '../../../utils/FormattersUtil';
import DatesUtil from '../../../utils/DatesUtil';
import { showToast } from '../../../utils/ToastsUtil';
import WebSocketUtil from '../../../utils/WebSocketUtil';

const $ = (str) => FormattersUtil.getNormalizedString(str);

class OrganizationMembers extends Component {
    state = {
        searchQuery: '',
        linkedUsers: [],
        organizationAccessRequests: [],
        invitations: [],
        usersToAdd: [],
        usersOptions: [],
        notAddedUsers: null,
        isLoading: false,
        userSearch: '',
    }

    render() {
        const { activeOrganization, loginAsData } = this.props;
        const { searchQuery, organizationAccessRequests, linkedUsers, invitations, userSearch, usersToAdd, usersOptions, notAddedUsers, isLoading } = this.state;
        const isMaxLinkedUsersReached = linkedUsers.filter(lu => !lu.isOwner).length + 1 >= activeOrganization.subscription.nbUsers;

        const userId = jwtDecode(new Cookies().get('token')).id;
        const usersToRender = linkedUsers.filter(user => user.id !== userId && (!userSearch?.trim() || (
            $(user.email)?.includes($(userSearch)) ||
            $(user.firstName)?.includes($(userSearch)) ||
            $(user.lastName)?.includes($(userSearch))
        )));

        const isOwner = activeOrganization?.userOrganizations.find(uo => uo.isOwner && uo.userId === userId) ? true : false;
        const organizationOwner = activeOrganization?.linkedUsers.find(user => user.isOwner);
        const nbLinkedUsers = activeOrganization?.linkedUsers?.length || 0;
        const nbInvitations = activeOrganization?.invitations?.filter(i => i.status !== 'declined')?.length || 0;

        return (
            <>
                <SubscriptionUsersLimitReachedMessage />
                {isOwner && activeOrganization?.subscription?.nbUsers > 1 &&
                    <Form onSubmit={() => this.handleUsersSubmit()} error style={{ marginBottom: 'var(--spacing-md)' }}>
                        <Form.Field
                            control={Select} label={`${i18n.t("Ajouter des utilisateurs")} :`} placeholder={i18n.t("Saisissez des adresses mails")}
                            name='user' options={usersOptions} value={usersToAdd || ''} disabled={isMaxLinkedUsersReached || loginAsData?.readOnly}
                            selectOnBlur={false} multiple selection search={FormattersUtil.searchList} allowAdditions open={false} // Pour en faire un input multiple
                            searchQuery={searchQuery}
                            onSearchChange={(_, { searchQuery }) => this.setState({ searchQuery: searchQuery })} // On sauvegarde la recherche dans le state
                            onChange={this.handleChange} onKeyUp={this.handleUsersChange}
                        />
                        <Button
                            className='form-button' type='submit' color='blue' style={{ marginTop: 'var(--spacing-sm)' }}
                            disabled={isMaxLinkedUsersReached || isLoading || loginAsData?.readOnly} loading={isLoading}
                        >
                            <FontAwesomeIcon icon={faPlus} style={{ marginLeft: 0, marginRight: '10px' }} />{i18n.t("Ajouter")}
                        </Button>
                        {notAddedUsers &&
                            <Message error
                                header={`${i18n.t("Les utilisateurs suivants n'ont pas pu être ajoutés")} :`}
                                list={Object.keys(notAddedUsers).map(mail => mail + ' : ' + notAddedUsers[mail])}
                            />}
                    </Form>}
                <div style={{ display: 'flex', flexDirection: isMobileOnly ? 'column' : 'row', gap: 'var(--spacing-sm)', alignItems: 'flex-end', width: '100%', marginBottom: 'var(--spacing-md)', textAlign: isMobileOnly ? 'center' : 'left' }}>
                    <Form style={{ marginTop: 'var(--spacing-xs)', width: isMobileOnly ? '100%' : '250px' }}>
                        <Form.Field control={Input} placeholder={i18n.t("Adresse e-mail, nom, ...")} title={i18n.t("Adresse e-mail, nom, ...")} value={userSearch} onChange={(_, { value }) => this.setState({ userSearch: value })} icon='search' iconPosition='left' style={{ margin: 0 }} />
                    </Form>
                    <Label color={nbLinkedUsers ? 'blue' : undefined} style={{ display: 'flex', alignItems: 'center', justifyContent: isMobileOnly && 'center', width: isMobileOnly ? '100%' : 'auto', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px', aspectRatio: '1/1' }} />
                        {nbLinkedUsers !== 1 ? i18n.t("{{nb}} utilisateurs actifs", { nb: nbLinkedUsers }) : i18n.t("1 utilisateur actif")}
                    </Label>
                    <Label color={nbInvitations ? 'blue' : undefined} style={{ display: 'flex', alignItems: 'center', justifyContent: isMobileOnly && 'center', width: isMobileOnly ? '100%' : 'auto', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '10px', aspectRatio: '1/1' }} />
                        {nbInvitations !== 1 ? i18n.t("{{nb}} invitations en attente", { nb: nbInvitations }) : i18n.t("1 invitation en attente")}
                    </Label>
                    {!isOwner && organizationOwner &&
                        <Button
                            color='red' type='button' className='form-button' style={{ marginLeft: 'auto' }}
                            loading={isLoading} disabled={isLoading || loginAsData?.readOnly} onClick={this.leaveSubscriptionSharing}
                        >
                            <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '10px' }} />
                            {i18n.t("Quitter l'organisation")}
                        </Button>}
                </div>
                <Grid className='org-table' style={{ margin: 0 }}>
                    <Grid.Row stretched style={{ fontWeight: 'bold', paddingBottom: 0 }}>
                        <Grid.Column computer={5} tablet={5} mobile={12}>{i18n.t("Adresse e-mail")}</Grid.Column>
                        <Grid.Column width={3} className='org-col-hide-mobile'>{i18n.t("Nom")}</Grid.Column>
                        <Grid.Column width={3} className='org-col-hide-mobile'>{i18n.t("Prénom")}</Grid.Column>
                        {isOwner && <Grid.Column computer={5} tablet={5} mobile={4} />}
                    </Grid.Row>
                    <Divider style={{ margin: '10px 0' }} />
                    <Grid.Row style={{ height: '350px', maxHeight: '350px', overflow: 'auto' }}>
                        <Grid.Column>
                            {usersToRender.length > 0 || invitations.length ?
                                <Grid>
                                    {usersToRender.length > 0 && this.renderLinkedUsers(usersToRender, isOwner)}
                                    {organizationAccessRequests.length > 0 &&
                                        <>
                                            <Divider style={{ width: '100%', marginTop: 0, marginBottom: 0 }} />
                                            {this.renderorganizationAccessRequests(isOwner)}
                                        </>}
                                    {invitations.filter(i => i.status !== 'declined').length > 0 &&
                                        <>
                                            <Divider style={{ width: '100%', marginTop: 0, marginBottom: 0 }} />
                                            {this.renderInvitations(isOwner)}
                                        </>}
                                </Grid>
                                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                                    <FontAwesomeIcon icon={faUsers} size='6x' />
                                    <p style={{ margin: '10px 0 0 0' }}>{i18n.t("Aucun utilisateur trouvé.")}</p>
                                </div>}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </>
        );
    }

    componentDidMount = () => {
        this.setState({
            organizationAccessRequests: this.props.activeOrganization.organizationAccessRequests,
            linkedUsers: this.props.activeOrganization.linkedUsers,
            invitations: this.props.activeOrganization.invitations
        });
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.activeOrganization && this.props.activeOrganization
            && (JSON.stringify(prevProps.activeOrganization.organizationAccessRequests) !== JSON.stringify(this.props.activeOrganization.organizationAccessRequests)
                || JSON.stringify(prevProps.activeOrganization.linkedUsers) !== JSON.stringify(this.props.activeOrganization.linkedUsers)
                || JSON.stringify(prevProps.activeOrganization.invitations) !== JSON.stringify(this.props.activeOrganization.invitations))
        )
            this.setState({
                organizationAccessRequests: this.props.activeOrganization.organizationAccessRequests,
                linkedUsers: this.props.activeOrganization.linkedUsers,
                invitations: this.props.activeOrganization.invitations
            });
    }

    renderLinkedUsers = (usersToRender, isOwner) => (
        usersToRender.map(linkedUser => (
            <Grid.Row key={linkedUser.id} stretched>
                <Grid.Column computer={5} tablet={5} mobile={12}>{linkedUser.email}</Grid.Column>
                <Grid.Column width={3} className='org-col-hide-mobile'>{linkedUser.lastName}</Grid.Column>
                <Grid.Column width={3} className='org-col-hide-mobile'>{linkedUser.firstName}</Grid.Column>
                {isOwner &&
                    <Grid.Column computer={5} tablet={5} mobile={4} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                        <Button
                            color='red' disabled={this.props.loginAsData?.readOnly} title={i18n.t("Retirer l'utilisateur")}
                            onClick={() => this.handleRemoveLinkedUser(linkedUser)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <FontAwesomeIcon icon={faTrashAlt} style={{ marginRight: !isMobileOnly && '5px' }} />
                            {!isMobileOnly && i18n.t('Retirer')}
                        </Button>
                    </Grid.Column>}
            </Grid.Row>
        ))
    );

    renderorganizationAccessRequests = (isOwner) => {
        const { organizationAccessRequests, invitations } = this.state;
        const organizationAccessRequestsToRender = organizationAccessRequests.filter(ar => !invitations.find(inv => inv.id === ar.invitationId));

        return organizationAccessRequestsToRender.map(accessRequest => {
            return (
                <Grid.Row key={accessRequest.id} stretched>
                    <Grid.Column computer={5} tablet={5} mobile={12}>{accessRequest.invitedEmail}</Grid.Column>
                    <Grid.Column width={6} className='org-col-hide-mobile'>
                        <p>
                            {i18n.t("Demande d'accès par {{requesterEmail}}, en attente d'une réponse du propriétaire de l'organisation", { requesterEmail: accessRequest.requesterUser?.email })}
                            <span style={{ marginLeft: '5px' }}>
                                ({DatesUtil.convertUTCDateToLocaleDate(accessRequest.date)})
                            </span>
                        </p>
                    </Grid.Column>
                    {isOwner &&
                        <Grid.Column computer={5} tablet={5} mobile={4} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                            {accessRequest &&
                                <Button
                                    color='green' disabled={this.props.loginAsData?.readOnly} title={i18n.t("Accepter la demande d'accès")}
                                    onClick={() => this.handleDecideOrganizationAccessRequest(accessRequest, true)}
                                >
                                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                                    {i18n.t('Accepter')}
                                </Button>}
                            <Button
                                color='red' disabled={this.props.loginAsData?.readOnly} title={i18n.t("Refuser la demande d'accès")}
                                onClick={() => this.handleDecideOrganizationAccessRequest(accessRequest, false)}
                            >
                                <FontAwesomeIcon icon={accessRequest ? faTimes : faTrashAlt} style={{ marginRight: '5px' }} />
                                {i18n.t('Refuser')}
                            </Button>
                        </Grid.Column>}
                </Grid.Row>
            );
        });
    }

    renderInvitations = (isOwner) => {
        const { organizationAccessRequests, invitations } = this.state;

        return invitations
            .filter(invitation => invitation.status !== 'declined')
            .map(invitation => {
                const accessRequest = organizationAccessRequests.find(ar => ar.invitationId === invitation.id);

                return (
                    <Grid.Row key={invitation.id} stretched>
                        <Grid.Column computer={5} tablet={5} mobile={12}>{invitation.email}</Grid.Column>
                        <Grid.Column width={6} className='org-col-hide-mobile'>
                            <p>
                                {accessRequest
                                    ? i18n.t("Demande d'accès par {{requesterEmail}}, en attente d'une réponse du propriétaire de l'organisation ainsi que de l'utilisateur invité", { requesterEmail: accessRequest.requesterUser?.email })
                                    : i18n.t("Invité, en attente d'une réponse de sa part")}
                                <span style={{ marginLeft: '5px' }}>
                                    ({DatesUtil.convertUTCDateToLocaleDate(invitation.date)})
                                </span>
                            </p>
                        </Grid.Column>
                        {isOwner &&
                            <Grid.Column computer={5} tablet={5} mobile={4} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                                {accessRequest &&
                                    <Button
                                        color='green' disabled={this.props.loginAsData?.readOnly} title={i18n.t("Accepter la demande d'accès")}
                                        onClick={() => this.handleDecideOrganizationAccessRequest(accessRequest, true)}
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: !isMobileOnly && '5px' }} />
                                        {!isMobileOnly && i18n.t('Accepter')}
                                    </Button>}
                                <Button
                                    color='red' disabled={this.props.loginAsData?.readOnly} title={accessRequest ? i18n.t("Refuser la demande d'accès") : i18n.t("Supprimer l'invitation")}
                                    onClick={() => accessRequest ? this.handleDecideOrganizationAccessRequest(accessRequest, false) : this.handleRemoveInvitation(invitation)}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <FontAwesomeIcon icon={accessRequest ? faTimes : faTrashAlt} style={{ marginRight: !isMobileOnly && '5px' }} />
                                    {!isMobileOnly &&
                                        <>
                                            {accessRequest
                                                ? i18n.t('Refuser')
                                                : i18n.t('Supprimer')}
                                        </>}
                                </Button>
                            </Grid.Column>}
                    </Grid.Row>
                );
            });
    }

    getFormattedValue = (value, maxValue) => maxValue !== -1 ? (value / maxValue * 100) % 1 ? ((value / maxValue * 100).toFixed(2)) : (value / maxValue * 100) : 0;
    handleRemoveLinkedUser = (userToRemove) => {
        OrganizationsService.removeUserFromOrganization(userToRemove.id, false).then(() => {
            this.setState(prevState => ({
                linkedUsers: prevState.linkedUsers.filter(user => user.id !== userToRemove.id)
            }));

            this.props.setActiveOrganization({
                ...this.props.activeOrganization,
                linkedUsers: this.props.activeOrganization.linkedUsers.filter(user => user.id !== userToRemove.id)
            });

            WebSocketUtil.removeOrganization(this.props.webSocketHubs, [userToRemove.id], this.props.activeOrganization.id);
            WebSocketUtil.removeUserOrganizations(this.props.webSocketHubs, this.props.activeOrganization.id, [userToRemove.id]);
        });
    }

    handleRemoveInvitation = (invitation) => {
        OrganizationsService.removeInvitationFromOrganization(invitation.id).then((response) => {
            if (response) {
                this.setState(prevState => ({
                    invitations: prevState.invitations.filter(i => i.email !== invitation.email)
                }));

                this.props.setActiveOrganization({
                    ...this.props.activeOrganization,
                    invitations: this.props.activeOrganization.invitations.filter(i => i.email !== invitation.email)
                });

                WebSocketUtil.removeOrganizationInvitations(this.props.webSocketHubs, this.props.activeOrganization.id, [invitation.id]);
            }
        });
    }

    handleUsersSubmit = () => {
        const { searchQuery } = this.state;
        let usersToAdd = this.state.usersToAdd;
        if (FormattersUtil.checkEmail(searchQuery))
            usersToAdd = [...usersToAdd, searchQuery];
        if (usersToAdd.length > 0) {
            this.setState({ notAddedUsers: null, isLoading: true });
            OrganizationsService.addUsersToOrganization(this.props.activeOrganization.id, null, usersToAdd, true).then(response => {
                let linkedUsers = JSON.parse(JSON.stringify(this.state.linkedUsers));
                let invitations = JSON.parse(JSON.stringify(this.state.invitations));

                if (response?.addedUsers?.length) {
                    linkedUsers.push(...response.addedUsers);
                    WebSocketUtil.sendUserOrganizations(this.props.webSocketHubs, this.props.activeOrganization.id, response.addedUsers.map(au => ({ ...au, organizationId: this.props.activeOrganization.id })));
                }

                if (response?.invitations?.length) {
                    invitations = invitations.filter(i => !response.invitations.find(im => i.email === im.email))
                    invitations.push(...response.invitations);
                    WebSocketUtil.sendOrganizationInvitations(this.props.webSocketHubs, this.props.activeOrganization.id, response.invitations);
                }

                this.props.setActiveOrganization({ ...this.props.activeOrganization, linkedUsers, invitations });
                if (response?.notAddedUsers && Object.keys(response.notAddedUsers).length > 0)
                    this.setState({ notAddedUsers: response.notAddedUsers });
                this.setState({ linkedUsers, invitations, usersToAdd: [], usersOptions: [], searchQuery: '', isLoading: false });
            });
        }
    }

    handleUsersChange = (e) => {
        if (e.keyCode === 32) { // Lorsqu'on appuie sur 'espace'
            if (FormattersUtil.checkEmail(this.state.searchQuery)) {
                this.setState(prevState => {
                    const searchQuery = prevState.searchQuery.trim();
                    return {
                        searchQuery: '', // On réinitialise la recherche
                        // On ajoute la recherche dans les options et dans les valeurs sélectionnées
                        usersToAdd: prevState.usersToAdd.find(x => x === searchQuery)
                            ? prevState.usersToAdd
                            : [...prevState.usersToAdd, searchQuery],
                        usersOptions: prevState.usersOptions.find(x => x.text === searchQuery)
                            ? prevState.usersOptions
                            : [...prevState.usersOptions, { text: searchQuery, value: searchQuery }]
                    }
                });
            } else showToast('email_not_valid');
        }
    }

    handleChange = (_, { value }) => { // Permet de gérer le 'remove' de l'input d'ajout
        this.setState({
            usersToAdd: value,
            usersOptions: value.map(x => ({ text: x, value: x }))
        });
    }

    handleDecideOrganizationAccessRequest = (organizationAccessRequest, isAccepted) => {
        OrganizationsService.decideOrganizationAccessRequest(organizationAccessRequest.id, isAccepted).then(response => {
            if (response) {
                const { linkedUser } = response;
                let invitations = JSON.parse(JSON.stringify(this.state.invitations));
                if (organizationAccessRequest.invitationId) {
                    let invitation = invitations.find(i => i.id === organizationAccessRequest.invitationId);
                    if (invitation) invitation.status = isAccepted ? 'accepted' : 'declined';
                }

                this.setState(prevState => ({
                    linkedUsers: linkedUser ? [...prevState.linkedUsers, linkedUser] : prevState.linkedUsers,
                    organizationAccessRequests: prevState.organizationAccessRequests.filter(oar => oar.id !== organizationAccessRequest.id),
                    invitations: [...invitations]
                }), () => {
                    this.props.setActiveOrganization({
                        ...this.props.activeOrganization,
                        linkedUsers: linkedUser ? [...this.props.activeOrganization.linkedUsers, linkedUser] : this.props.activeOrganization.linkedUsers,
                        organizationAccessRequests: this.props.activeOrganization.organizationAccessRequests.filter(oar => oar.id !== organizationAccessRequest.id),
                        invitations: [...invitations]
                    });
                });
            }
        });
    }

    leaveSubscriptionSharing = () => {
        const { activeOrganization } = this.props;
        const userId = jwtDecode(new Cookies().get('token')).id;

        const isOrganizationOwner = activeOrganization?.userOrganizations.find(uo => uo.isOwner && uo.userId === userId) ? true : false;
        if (isOrganizationOwner) return;

        const organization = this.props.organizations.find(o => o.id !== this.props.activeOrganization.id);
        if (!organization) return;

        OrganizationsService.removeUserFromOrganization(userId, true).then((response) => {
            if (response) {
                WebSocketUtil.removeOrganization(this.props.webSocketHubs, [userId], this.props.activeOrganization.id);
                WebSocketUtil.removeUserOrganizations(this.props.webSocketHubs, this.props.activeOrganization.id, [userId]);

                setTimeout(() => {
                    OrganizationsService.updateActiveOrganization(organization.id).then((response) => {
                        if (response) window.location.reload();
                    });
                }, 500);
            }
        });
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.isOnline,
        organizations: state.organizations,
        activeOrganization: state.activeOrganization,
        loginAsData: state.loginAsData,
        webSocketHubs: state.webSocketHubs,
    };
}

const mapDispatchToProps = {
    setActiveOrganization
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationMembers);